// 阅读、分享文章积分接口，需要token
function addIntegral(axios, params) {
    // 判断是否登录
    if (localStorage.getItem('token') == undefined || localStorage.getItem('token') == '') {
        console.log('未登录');
        return
    }

    return axios.get("appapi/app/cmsInterface/articleCredit", {
        params
    })
}

export default {
    addIntegral
}